import { TimeoutError } from 'ky';

const DEFAULT_ERROR_MESSAGE = 'Failed to send';
const TIMEOUT_ERROR_MESSAGE = 'The request timed out while sending the message. Please retry.';

/**
 * Maps an error thrown while sending a single message in a bulk send to a
 * message safe to show a landlord. Network-level errors like ky's
 * `TimeoutError` carry the raw request method/URL in `.message`, so they must
 * never be shown directly - only a backend-issued `.msg` is pre-vetted as
 * user-facing.
 */
export const getBulkSendErrorMessage = (error: any): string => {
    if (error instanceof TimeoutError) {
        return TIMEOUT_ERROR_MESSAGE;
    }

    if (error?.messages?.length === 1 && error.messages[0]?.msg) {
        return error.messages[0].msg;
    }

    if (error?.msg) {
        return error.msg;
    }

    return DEFAULT_ERROR_MESSAGE;
};
